export default [
  {
    path: "/financeOverview",
    name: "FinanceOverview",
    component: () =>
      import(
        /* webpackChunkName: "financeOverview" */ "@/views/FinanceOverview/"
      ),
  },
  {
    path: "/financeByod",
    name: "FinanceByod",
    component: () =>
      import(/* webpackChunkName: "financeByod" */ "@/views/FinanceByod/"),
  },
  {
    path: "/financeEvents",
    name: "FinanceEvents",
    component: () =>
      import(/* webpackChunkName: "financeEvents" */ "@/views/FinanceEvents/"),
    children: [
      {
        name: "FinanceEventDetail",
        path: ":id",
        component: () =>
          import(
            /* webpackChunkName: "FinanceEventDetail" */ "@/views/FinanceEvents/Detail.vue"
          ),
        props: true,
      },
    ],
  },
  {
    path: "/financePrints",
    name: "FinancePrints",
    component: () =>
      import(/* webpackChunkName: "FinancePrints" */ "@/views/FinancePrints/"),
    props: true,
    children: [
      {
        name: "FinancePrintsDetail",
        path: ":id",
        component: () =>
          import(
            /* webpackChunkName: "FinancePrintsDetail" */ "@/views/FinancePrints/Detail.vue"
          ),
        props: true,
      },
    ],
  },
  {
    path: "/financeInvoices",
    component: () =>
      import(
        /* webpackChunkName: "FinanceInvoices" */ "@/views/FinanceInvoices/"
      ),
    props: true,
    children: [
      {
        path: "",
        name: "FinanceInvoices",
        redirect: "/financeInvoices/submitted",
      },
      {
        name: "FinanceInvoicesSubmitted",
        path: "submitted",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesSubmitted" */ "@/views/FinanceInvoices/Submitted.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesSubmittedAdd",
            path: "add",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesSubmittedAdd" */ "@/views/FinanceInvoices/Edit.vue"
              ),
            props: { id: 0 },
          },
          {
            name: "FinanceInvoicesSubmittedEdit",
            path: "edit/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesSubmittedEdit" */ "@/views/FinanceInvoices/Edit.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesSubmittedDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesSubmittedDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesSubmittedGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesSubmittedGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
      {
        name: "FinanceInvoicesSubmittedSap",
        path: "submittedSap",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesSubmittedSap" */ "@/views/FinanceInvoices/SubmittedSap.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesSubmittedSapDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesSubmittedSapDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesSubmittedSapGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesSubmittedSapGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
      {
        name: "FinanceInvoicesForeign",
        path: "foreign",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesForeign" */ "@/views/FinanceInvoices/Foreign.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesForeignDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesForeignDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesForeignGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesForeignGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
      {
        name: "FinanceInvoicesNoDetails",
        path: "noDetails",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesNoDetails" */ "@/views/FinanceInvoices/NoDetails.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesNoDetailsDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesNoDetailsDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesNoDetailsDistribute",
            path: "detail/:id/distribute",

            component: () => import("@/views/FinanceInvoices/Distribute.vue"),
            props: true,
          },
          {
            name: "FinanceInvoicesNoDetailsGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesNoDetailsGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },

      {
        name: "FinanceInvoicesDepartments",
        path: "departments",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesDepartments" */ "@/views/FinanceInvoices/Departments.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesDepartmentsDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesDepartmentsDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesDepartmentsDistribute",
            path: "detail/:id/distribute",

            component: () => import("@/views/FinanceInvoices/Distribute.vue"),
            props: true,
          },
          {
            name: "FinanceInvoicesDepartmentsGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesDepartmentsGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
      {
        name: "FinanceInvoicesEntered",
        path: "entered",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesEntered" */ "@/views/FinanceInvoices/Entered.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesEnteredDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesEnteredDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesEnteredGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesEnteredGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
      {
        name: "FinanceInvoicesRejected",
        path: "rejected",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesRejected" */ "@/views/FinanceInvoices/Rejected.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesRejectedDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesRejectedDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesRejectedGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesRejectedGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
      {
        name: "FinanceInvoicesTransfers",
        path: "transfers",
        component: () =>
          import(
            /* webpackChunkName: "FinanceInvoicesTransfers" */ "@/views/FinanceInvoices/Transfers.vue"
          ),
        props: true,
        children: [
          {
            name: "FinanceInvoicesTransfersDetail",
            path: "detail/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesTransfersDetail" */ "@/views/FinanceInvoices/Detail.vue"
              ),
            props: true,
          },
          {
            name: "FinanceInvoicesTransfersGroup",
            path: "group/:id",
            component: () =>
              import(
                /* webpackChunkName: "FinanceInvoicesTransfersGroup" */ "@/views/FinanceInvoices/Group.vue"
              ),
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: "/financePerson",
    name: "FinancePerson",
    component: () =>
      import(/* webpackChunkName: "FinancePerson" */ "@/views/FinancePerson/"),
    props: true,
    children: [
      {
        name: "FinancePersonDetail",
        path: ":id",
        component: () =>
          import(
            /* webpackChunkName: "FinancePersonDetail" */ "@/views/FinancePerson/Detail.vue"
          ),

        props: true,
      },
    ],
  },
];
